import type { ReactStripeElements } from 'react-stripe-elements';

/**
 * Create a Stripe token from a credit card. This will use the Stripe api directly and not hit our server.
 * credit card data comes from a Stripe Elements iframe - https://stripe.com/docs/recipes/elements-react
 *
 * @param {ReactStripeElements.StripeProps} stripe - the stripe session which references our credit card information
 * @return {String} Returns the stripe token ID
 * @throws {{ stripeError: Object }}
 */
export const createStripeToken = async (stripe: ReactStripeElements.StripeProps) => {
  const token = await stripe.createToken();

  if (token.error) {
    throw new Error(token.error.message);
  }

  return token?.token?.id;
};
